// Layar Personil per Tahap Kerja — arti kotak tiap baris (PENGECUALIAN 8, Owner 3 Nov 2026; K229/K230). MURNI.
//
// Sejak K230 Ketua sebuah baris bisa berarti dua hal, dan layar wajib menyebut yang mana:
//   * penerima TUGAS HARIAN (tahap kerja selain Jahit) — penanda backend `tugas_harian`;
//   * penerima SERAH TERIMA lewat Telegram (Jahit, Finishing, QC/Packing, Gudang Barang Jadi) — `penerima_serah_terima`
//     + `serah_dari`.
// Jahit: tugas harian tetap ke ketua GROUP (bagian Group Jahit); Ketua di baris ini = penerima serah terima dari Potong.
// Gudang Barang Jadi: bukan pekerjaan, tidak menerima tugas harian. Penandanya dari backend, bukan dikarang di sini.
import { labelTahap } from "./papanKerjaApi";

/** Satu kalimat arti Ketua baris ini. */
export function artiKetua(t) {
  const bagian = [];
  if (t?.tugas_harian) bagian.push("menerima tugas harian");
  if (t?.penerima_serah_terima) {
    bagian.push(`mencatat serah terima dari ${labelTahap(t.serah_dari)} lewat Telegram`);
  }
  if (!bagian.length) return "";
  return `Ketua ${bagian.join(" dan ")}.`;
}

/** Keterangan tambahan untuk baris yang bukan tahap kerja biasa. */
export function keteranganBaris(t) {
  if (t?.dilayani_group) {
    return "Tugas harian Jahit tetap dikirim ke ketua group (bagian Group Jahit). Ketua di sini khusus penerima "
      + "barang dari Potong.";
  }
  if (t?.penerima_serah_terima && !t?.tugas_harian) {
    return "Bukan tahap kerja — tidak menerima tugas harian.";
  }
  return "";
}

/** Peringatan "belum punya ketua" — menghitung tahap kerja DAN tahap penerima serah terima (termasuk Jahit &
 *  Gudang Barang Jadi), dengan akibat yang disebut terpisah. */
export function ringkasTanpaKetua(tahap = []) {
  const kosong = tahap.filter((t) => (t.tugas_harian || t.penerima_serah_terima) && !t.ketua);
  const akibat = [];
  if (kosong.some((t) => t.tugas_harian)) akibat.push("tugas hariannya belum punya penanggung jawab");
  if (kosong.some((t) => t.penerima_serah_terima)) {
    akibat.push("serah terima ke tahap itu lewat Telegram ditolak dan harus dicatat Admin Produksi di layar");
  }
  return {
    jumlah: kosong.length,
    nama: kosong.map((t) => labelTahap(t.code)),
    kalimat: akibat.length ? `${akibat.join("; ")}.` : "",
  };
}
